import {TieredRadioButtonForm} from './tiered-radio-button-form';

export class FormNumber extends TieredRadioButtonForm {
    getFields = () => {
        const fields = [
            {
                id: 'Equals',
                value: 'Equals',
            },
            {
                id: 'Greater than',
                value: 'Greater than',
            },
            {
                id: 'Less than',
                value: 'Less than',
            },
        ];

        if (this.props.isNumber) {
            fields.push({id: 'Between', value: 'Between'});
        }

        if (this.props.anyOptionText) {
            fields.push({id: 'any', value: this.props.anyOptionText});
        }

        if (this.props.nullOptionText) {
            fields.push({id: 'null', value: this.props.nullOptionText});
        }

        return fields;
    };
}
